define([
    'santa-components',
    'tpaGalleries/galleries/tpaGallery',
    'tpaGalleries/galleries/tpaGalleryCurrentItemMixin'
], function (santaComponents, tpaGallery, tpaGalleryCurrentItemMixin) {
    'use strict';
    /**
     * @class components.stripShowcase
     * @extends {core.tpaGallery}
     * @extends {core.tpaStripGallery}
     */
    return {
        displayName: 'StripShowcaseGallery',
        mixins: [tpaGallery, tpaGalleryCurrentItemMixin],
        propTypes: {
            screenSize: santaComponents.santaTypesDefinitions.screenSize.isRequired
        },
        isScreenWidth() { return true; },
        statics: {
            behaviors: {
                nextSlide: {methodName: 'next'},
                prevSlide: {methodName: 'prev'}
            }
        },
        getGalleryType() {
            return 'StripShowcase';
        },
        getStyleProps() {
            return {};
        }
    };
});
